import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const nescRouter = new Router({
  mode: 'hash', // 去掉#号
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/404',
      component: () => import('./views/404'),
      hidden: true
    },
    {
      path: '/industrySolutions/:type',
      name: 'industrySolutions',
      component: () => import('./views/IndustrySolutions.vue')
    },
    {
      path: '/productSolutions/:type',
      name: 'productSolutions',
      component: () => import('./views/ProductSolutions.vue')
    },
    {
      path: '/techAdvantages/:type',
      name: 'techAdvantages',
      component: () => import('./views/TechAdvantages.vue')
    },
    {
      path: '/aboutUs/:type',
      name: 'aboutUs',
      component: () => import('./views/About.vue')
    },
    {
      path: '/shunDianCloud',
      name: 'shunDianCloud',
      component: () => import('./views/ShunDianCloud.vue')
    },
    {
      path: '/agent',
      name: 'agent',
      component: () => import('./views/Agent.vue')
    },
    {
      path: '/newsDetail/:id/:time',
      name: 'newsDetail',
      component: () => import('./views/NewsDetail.vue')
    },
    {
      path: '*',
      redirect: '/404',
      hidden: true
    }
  ]
})

export default nescRouter
